module.exports = __webpack_public_path__ + "static/media/promulgation-landing-in-outdoor-ad.cbfe9aa2.png";